(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["apparel-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndc-apparel-size-guide')) {
    customElements.define('ndc-apparel-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-guide-open]');
        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-guide-open]')) {
            this.updateSelectedSize();
            this.dialog.showModal();
            document.documentElement.classList.add('ndc-size-guide-open');
          } else if (event.target.closest('[data-guide-close]')) {
            this.dialog.close();
          } else if (event.target.closest('[data-guide-unit]')) {
            this.setUnit(event.target.closest('[data-guide-unit]').dataset.guideUnit);
          } else if (event.target === this.dialog && this.backdropPress) {
            const bounds = this.dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
          }
        }, options);
        this.dialog.addEventListener('pointerdown', (event) => {
          this.backdropPress = event.target === this.dialog;
        }, options);
        this.dialog.addEventListener('close', () => {
          this.unlockScroll();
          if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.unlockScroll();
      }
      unlockScroll() {
        if (!document.querySelector('.ndc-sg__dialog[open]')) document.documentElement.classList.remove('ndc-size-guide-open');
      }
      updateSelectedSize() {
        const option = this.closest('.m-product-option__inner');
        const field = option?.querySelector('input[type="radio"]:checked, select');
        const selected = (field?.value || option?.dataset.selectedValue || this.dataset.selectedSize || '').trim().toLowerCase();
        this.querySelectorAll('[data-guide-size]').forEach((row) => {
          const current = row.dataset.guideSize.trim().toLowerCase() === selected;
          row.classList.toggle('ndc-sg__selected', current);
          row.querySelector('[data-guide-selected]').hidden = !current;
        });
      }
      setUnit(unit) {
        if (!['cm', 'in'].includes(unit)) return;
        this.querySelectorAll('[data-guide-unit]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.guideUnit === unit)));
        this.querySelectorAll('[data-guide-cm]').forEach((cell) => { cell.textContent = cell.getAttribute('data-guide-' + unit); });
        const label = this.querySelector('[data-guide-unit="' + unit + '"]').textContent;
        this.querySelectorAll('[data-guide-unit-label]').forEach((element) => { element.textContent = label; });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["birthstone-colour-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('birthstone-colour-picker')) {
    customElements.define('birthstone-colour-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.select = this.querySelector('select');
        this.enhanced = this.querySelector('.birthstone-picker__enhanced');
        this.trigger = this.querySelector('.birthstone-picker__trigger');
        this.panel = this.querySelector('.birthstone-picker__panel');
        this.valueText = this.querySelector('.birthstone-picker__value');
        this.selectedImage = this.querySelector('[data-selected-image]');
        this.placeholder = this.querySelector('[data-placeholder]');
        this.error = this.querySelector('.birthstone-picker__error');
        this.choices = Array.from(this.querySelectorAll('.birthstone-picker__choice'));
        this.label = this.closest('.m-product-custom-field').querySelector('label');
        if (!this.select || !this.label || this.choices.length !== 12) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.label.id = this.trigger.id + '-label';
        this.label.htmlFor = this.trigger.id;
        this.trigger.setAttribute('aria-labelledby', this.label.id + ' ' + this.valueText.id);
        this.panel.setAttribute('aria-labelledby', this.label.id);
        this.trigger.addEventListener('click', () => this.toggle(this.panel.hidden), { signal });
        this.trigger.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            this.toggle(true);
            (this.choices.find(choice => choice.dataset.value === this.select.value) || this.choices[0]).focus();
          }
        }, { signal });
        this.choices.forEach(choice => choice.addEventListener('click', () => {
          this.select.value = choice.dataset.value;
          this.select.dispatchEvent(new Event('input', { bubbles: true }));
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
          this.toggle(false, true);
        }, { signal }));
        this.addEventListener('keydown', event => {
          if (event.defaultPrevented) return;
          if (event.key === 'Escape' && !this.panel.hidden) {
            event.preventDefault();
            event.stopPropagation();
            this.toggle(false, true);
            return;
          }
          const index = this.choices.indexOf(document.activeElement);
          if (index < 0) return;
          const columns = getComputedStyle(this.panel).gridTemplateColumns.split(' ').length;
          const steps = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: columns, ArrowUp: -columns };
          let next;
          if (event.key in steps) next = (index + steps[event.key] + this.choices.length) % this.choices.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.choices.length - 1;
          if (next !== undefined) { event.preventDefault(); this.choices[next].focus(); }
        }, { signal });
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.toggle(false);
        }, { signal });
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.toggle(false);
        }, { signal });
        this.select.addEventListener('change', () => this.sync(), { signal });
        this.select.addEventListener('invalid', event => {
          event.preventDefault();
          this.showError(true);
          this.trigger.focus();
        }, { signal });
        this.form = document.getElementById(this.select.getAttribute('form'));
        if (this.form) {
          this.form.addEventListener('submit', () => {
            const invalid = this.select.required && !this.select.value;
            this.showError(invalid);
            const scope = this.closest('.m-main-product--info');
            const firstInvalid = Array.from(scope.querySelectorAll('birthstone-colour-picker')).find(picker => picker.select.required && !picker.select.value);
            if (invalid && firstInvalid === this) this.trigger.focus();
          }, { capture: true, signal });
          this.form.addEventListener('reset', () => queueMicrotask(() => { this.sync(); this.toggle(false); }), { signal });
        }
        this.sync();
        this.select.setAttribute('aria-hidden', 'true');
        this.select.tabIndex = -1;
        this.enhanced.hidden = false;
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        if (!this.controller) return;
        this.controller.abort();
        this.controller = null;
        this.label.htmlFor = this.select.id;
        this.select.removeAttribute('aria-hidden');
        this.select.removeAttribute('tabindex');
        this.enhanced.hidden = true;
        this.removeAttribute('data-ready');
      }
      toggle(open, returnFocus = false) {
        if (open) {
          this.closest('.m-main-product--info').querySelectorAll('birthstone-colour-picker').forEach(picker => {
            if (picker !== this && picker.controller) picker.toggle(false);
          });
        }
        this.panel.hidden = !open;
        this.trigger.setAttribute('aria-expanded', String(open));
        if (returnFocus) this.trigger.focus({ preventScroll: true });
      }
      sync() {
        const selected = this.choices.find(choice => choice.dataset.value === this.select.value);
        this.valueText.textContent = this.select.selectedOptions[0].textContent;
        this.placeholder.hidden = !!selected;
        this.selectedImage.hidden = !selected;
        if (selected) this.selectedImage.src = selected.querySelector('img').src;
        else this.selectedImage.removeAttribute('src');
        this.choices.forEach(choice => choice.setAttribute('aria-pressed', String(choice === selected)));
        this.select.classList.remove('form-control--warning');
        this.showError(false);
      }
      showError(invalid) {
        this.error.hidden = !invalid;
        if (invalid) {
          this.trigger.setAttribute('aria-invalid', 'true');
          this.trigger.setAttribute('aria-describedby', this.error.id);
        } else {
          this.trigger.removeAttribute('aria-invalid');
          this.trigger.removeAttribute('aria-describedby');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pet-portrait-upload"] && !Shopify.designMode) return;
  try {
    const petPortraitDesign = (() => {
  const clamp = value => Math.max(-100, Math.min(100, value));
  let fontPromise;

  function loadFont(url) {
    if (!fontPromise) {
      const face = new FontFace('PetPortraitScript', 'url(' + JSON.stringify(url) + ')', {weight:'600', style:'normal', display:'swap'});
      fontPromise = face.load().then(font => {
        document.fonts.add(font);
        return font;
      }).catch(error => {
        fontPromise = null;
        throw error;
      });
    }
    return fontPromise;
  }

  function layout(total, beach = false) {
    const area = beach ? {x:201, y:470, w:563, h:361} : {x:256, y:434, w:480, h:245};
    const cell = area.w / total;
    const grouped = total > 1;
    const size = grouped ? Math.min(area.h * .76, area.w * (total === 2 ? .78 : .87) / (1 + .74 * (total - 1))) : Math.min(area.h * .84, cell * .83);
    const step = size * .74;
    const groupWidth = size + step * (total - 1);
    const centerY = area.y + area.h * (grouped ? .42 : .48);
    const centers = Array.from({length:total}, (_, index) => area.x + area.w / 2 + (index - (total - 1) / 2) * step);
    return {area, cell, size, centerY, centers, groupWidth};
  }

  function geometry(image, processed, zoom, size) {
    const iw = image.naturalWidth || image.width;
    const ih = image.naturalHeight || image.height;
    const scale = (processed ? Math.min(size / iw, size / ih) * .92 : Math.max(size / iw, size / ih)) * zoom / 100;
    const width = iw * scale, height = ih * scale;
    return {width, height, rangeX:processed ? size * .38 : Math.max(0, (width - size) / 2), rangeY:processed ? size * .38 : Math.max(0, (height - size) / 2)};
  }

  function portrait(image, processed, crop, size) {
    const surface = document.createElement('canvas');
    surface.width = surface.height = Math.ceil(size * 2);
    const ctx = surface.getContext('2d');
    const d = surface.width;
    ctx.beginPath();
    ctx.arc(d / 2, d / 2, d / 2, 0, Math.PI * 2);
    ctx.clip();
    if (image) {
      const g = geometry(image, processed, crop.zoom, d);
      ctx.drawImage(image, (d - g.width) / 2 + crop.x / 100 * g.rangeX, (d - g.height) / 2 + crop.y / 100 * g.rangeY, g.width, g.height);
    }
    return surface;
  }

  function nameLines(ctx, name, maxWidth, fontSize) {
    const font = size => { ctx.font = '600 ' + size + 'px "PetPortraitScript", cursive'; };
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';
    ctx.fontKerning = 'normal';
    ctx.letterSpacing = '0px';
    const width = text => {
      const metrics = ctx.measureText(text);
      return Math.max(metrics.width, metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight);
    };
    let size = fontSize;
    font(size);
    const words = name.split(/\s+/);
    let lines = [name];
    if (width(name) > maxWidth * 1.35 && words.length > 1) {
      let best = Infinity;
      for (let i = 1; i < words.length; i++) {
        const pair = [words.slice(0, i).join(' '), words.slice(i).join(' ')];
        const widest = Math.max(...pair.map(width));
        if (widest < best) { best = widest; lines = pair; }
      }
    }
    while (Math.max(...lines.map(width)) > maxWidth && size > 1) font(size -= .5);
    return {lines, size, metrics:lines.map(line => ctx.measureText(line))};
  }

  function nameplate(ctx, name, cx, cy, size, maxWidth = size * .98) {
    if (!name) return;
    ctx.save();
      const {lines, size:fontSize, metrics} = nameLines(ctx, name, maxWidth - size * .18, size * .21);
      const ascent = Math.max(...metrics.map(m => m.actualBoundingBoxAscent));
      const descent = Math.max(...metrics.map(m => m.actualBoundingBoxDescent));
      const lineHeight = fontSize * 1.1;
      const textHeight = ascent + descent + (lines.length - 1) * lineHeight;
      const height = Math.max(size * .21, textHeight + size * .09);
      const width = Math.min(maxWidth, Math.max(size * .54, Math.max(...metrics.map(m => m.actualBoundingBoxLeft + m.actualBoundingBoxRight)) + size * .16));
      ctx.fillStyle = '#faf5e9';
      ctx.beginPath();
      ctx.roundRect(cx - width / 2, cy - height / 2, width, height, height * .22);
      ctx.fill();
      ctx.fillStyle = '#40332c';
      lines.forEach((line, i) => ctx.fillText(line, cx + (metrics[i].actualBoundingBoxLeft - metrics[i].actualBoundingBoxRight) / 2, cy - textHeight / 2 + ascent + i * lineHeight));
    ctx.restore();
  }

  function badge(ctx, image, processed, crop, name, cx, cy, size) {
    ctx.drawImage(portrait(image, processed, crop, size), cx - size / 2, cy - size / 2, size, size);
    if (image) nameplate(ctx, name, cx, cy + size * .395, size);
  }

  function combineNames(names) {
    const present = names.map(name => name.trim()).filter(Boolean);
    return present.length < 3 ? present.join(' & ') : present.slice(0, -1).join(', ') + ' & ' + present.at(-1);
  }

  function composition(ctx, pets, beach = false) {
    const {area, size, centerY, centers, groupWidth} = layout(pets.length, beach);
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.x, area.y, area.w, area.h);
    ctx.clip();
    pets.forEach((pet, index) => {
      if (pet.image) badge(ctx, pet.image, pet.processed, pet.crop, pets.length === 1 ? pet.name : '', centers[index], centerY, size);
    });
    if (pets.length > 1) {
      const name = combineNames(pets.filter(pet => pet.image).map(pet => pet.name));
      nameplate(ctx, name, area.x + area.w / 2, centerY + size * .46, Math.min(size * 1.15, area.h * .66), groupWidth * .94);
    }
    ctx.restore();
  }

  function point(canvas, event) {
    const rect = canvas.getBoundingClientRect();
    const side = Math.min(rect.width, rect.height);
    return {x:(event.clientX - rect.left - (rect.width - side) / 2) * canvas.width / side, y:(event.clientY - rect.top - (rect.height - side) / 2) * canvas.height / side};
  }

  function bind(canvas, targets, update, signal) {
    let drag = null;
    const options = signal ? {signal} : {};
    canvas.addEventListener('pointerdown', event => {
      if (!event.isPrimary || event.button !== 0) return;
      const start = point(canvas, event);
      const target = targets().filter(item => item.image && !item.loading && Math.hypot(start.x - item.cx, start.y - item.cy) <= item.size / 2).sort((a, b) => Math.hypot(start.x - a.cx, start.y - a.cy) - Math.hypot(start.x - b.cx, start.y - b.cy) || b.index - a.index)[0];
      if (!target) return;
      drag = {target, start, crop:{...target.crop}, geometry:geometry(target.image, target.processed, target.crop.zoom, target.size), pointer:event.pointerId};
      canvas.dataset.dragging = 'true';
      canvas.setPointerCapture(event.pointerId);
      event.preventDefault();
    }, options);
    canvas.addEventListener('pointermove', event => {
      if (!drag || drag.pointer !== event.pointerId) return;
      const current = point(canvas, event);
      const {rangeX, rangeY} = drag.geometry;
      update(drag.target.index, {zoom:drag.crop.zoom, x:rangeX ? Math.round(clamp(drag.crop.x + (current.x - drag.start.x) / rangeX * 100)) : 0, y:rangeY ? Math.round(clamp(drag.crop.y + (current.y - drag.start.y) / rangeY * 100)) : 0});
      event.preventDefault();
    }, options);
    const stop = event => {
      if (!drag || event.pointerId !== drag.pointer) return;
      drag = null;
      delete canvas.dataset.dragging;
    };
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => canvas.addEventListener(type, stop, options));
  }

  return {loadFont, layout, geometry, portrait, badge, combineNames, composition, bind};
})();

if (!customElements.get('pet-portrait-upload')) {
  customElements.define('pet-portrait-upload', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.form = this.closest('form');
      this.count = this.querySelector('[data-pet-count]');
      this.fields = [...this.querySelectorAll('[data-pet-file]')];
      this.canvas = this.querySelector('[data-preview-canvas]');
      this.context = this.canvas.getContext('2d');
      this.dialog = this.querySelector('dialog');
      this.largeCanvas = this.querySelector('[data-large-canvas]');
      this.states = this.fields.map(() => ({image: null, version: 0, loading: false}));
      this.examples = [];
      this.exampleNames = ['exampleOneName', 'exampleTwoName', 'exampleThreeName'].map(key => this.text(key));
      this.assets = {};
      this.serviceUrl = this.dataset.portraitService?.replace(/\/$/, '') || '';
      if (!/^https:\/\//.test(this.serviceUrl) && !/^http:\/\/(127\.0\.0\.1|localhost):\d+$/.test(this.serviceUrl)) this.serviceUrl = '';
      this.fields.forEach(field => {
        field.querySelector('[data-style-field]').hidden = !this.serviceUrl;
        field.querySelector('[data-portrait-style]').disabled = !this.serviceUrl || field.hidden;
      });
      this.templateReady = false;
      this.templateFailed = false;
      this.mountGallery(signal);
      this.mountCanvasGestures(signal);
      this.count.addEventListener('change', () => { this.syncFields(); this.setGalleryMode(true); this.render(); }, {signal});
      this.addEventListener('input', (event) => {
        this.querySelector('[data-design-error]').textContent = '';
        if (event.target.type !== 'file') this.render();
      }, {signal});
      this.addEventListener('change', (event) => {
        if (event.target.type === 'file' && event.target.closest('[data-pet-file]')) this.loadPhoto(event.target);
        if (event.target.matches('[data-portrait-style]')) this.processPortrait(this.fields.indexOf(event.target.closest('[data-pet-file]')));
      }, {signal});
      this.querySelector('[data-expand-preview]').addEventListener('click', () => {
        this.dialog.showModal();
        this.copyLarge();
      }, {signal});
      this.querySelector('[data-close-preview]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }
      }, {signal});
      this.fields.forEach((field) => {
        field.querySelector('[data-reset-crop]').addEventListener('click', () => {
          field.querySelectorAll('input[type=range]').forEach(input => { input.value = input.defaultValue; });
          this.render();
        }, {signal});
      });
      this.onVariant = (event) => {
        const variant = event.detail?.variant;
        if (variant && ![this.dataset.toteVariant, this.dataset.beachVariant].includes(String(variant.id))) return;
        this.updateVariant(variant?.id);
      };
      document.addEventListener('variant:changed', this.onVariant, {signal});
      this.form.addEventListener('change', () => this.updateVariant(), {signal});
      this.form.addEventListener('submit', (event) => {
        const input = this.querySelector('[data-design-file]');
        input.value = '';
        input.disabled = true;
        this.querySelector('[data-design-error]').textContent = '';
        if (!this.form.reportValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!this.templateReady) {
          this.blockDesignSubmit(event, this.text(this.templateFailed ? 'previewError' : 'loadingPreview'));
          return;
        }
        if (this.states.slice(0, Number(this.count.value)).some(state => !state.image || state.loading)) {
          this.blockDesignSubmit(event, this.text('processingPhoto'));
          return;
        }
        try {
          this.render();
          const data = this.canvas.toDataURL('image/png');
          if (!data.startsWith('data:image/png;base64,')) throw new Error('Preview export failed');
          const encoded = data.split(',')[1];
          const bytes = Uint8Array.from(atob(encoded), char => char.charCodeAt(0));
          if (!bytes.length) throw new Error('Empty preview');
          const transfer = new DataTransfer();
          transfer.items.add(new File([bytes], 'pet-bag-preview.png', {type: 'image/png'}));
          input.files = transfer.files;
          if (!input.files.length || !input.files[0].size) throw new Error('Preview attachment failed');
          input.disabled = false;
        } catch {
          input.value = '';
          input.disabled = true;
          this.blockDesignSubmit(event, this.text('exportError'));
        }
      }, {capture: true, signal});
      this.syncFields();
      this.updateVariant();
      this.loadAssets();
      this.loadExamples();
    }

    text(key) { return this.dataset[key] || ''; }

    blockDesignSubmit(event, message) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const error = this.querySelector('[data-design-error]');
      error.textContent = message;
      error.focus();
    }

    async loadImage(url, cors = false) {
      const image = new Image();
      if (cors) image.crossOrigin = 'anonymous';
      image.src = url;
      await image.decode();
      return image;
    }

    async loadAssets() {
      try {
        const [loaded] = await Promise.all([
          Promise.all(['tote', 'beach', 'beachOverlay'].map(async key => [key, await this.loadImage(this.dataset[key + 'Asset'], true)])),
          petPortraitDesign.loadFont(this.dataset.nameFontAsset),
        ]);
        if (!this.isConnected) return;
        this.assets = Object.fromEntries(loaded);
        this.templateReady = true;
      } catch {
        this.templateFailed = true;
      }
      this.render();
    }

    async loadExamples() {
      const results = await Promise.allSettled(['exampleOne', 'exampleTwo', 'exampleThree'].map(key => this.loadImage(this.dataset[key + 'Asset'], true)));
      if (!this.isConnected) return;
      this.examples = results.map(result => result.status === 'fulfilled' ? result.value : null);
      this.render();
    }

    async loadPhoto(input) {
      const index = this.fields.indexOf(input.closest('[data-pet-file]'));
      const state = this.states[index];
      const version = ++state.version;
      state.abort?.abort();
      state.image = null;
      state.sourceImage = null;
      state.results = new Map();
      state.processed = false;
      const processedInput = this.querySelector('[data-processed-file="' + (index + 1) + '"]');
      processedInput.value = '';
      processedInput.disabled = true;
      state.loading = false;
      const file = input.files[0];
      input.setCustomValidity('');
      if (!file) { this.render(); return; }
      if (!/\.(jpe?g|png|webp)$/i.test(file.name) || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
        input.setCustomValidity(this.text('fileError'));
        this.render();
        input.reportValidity();
        return;
      }
      state.loading = true;
      input.setCustomValidity(this.text('loadingPhoto'));
      this.render();
      const url = URL.createObjectURL(file);
      try {
        const image = await this.loadImage(url);
        if (state.version !== version || !this.isConnected) return;
        state.image = image;
        state.sourceImage = image;
        this.setGalleryMode(true);
        this.fields[index].querySelectorAll('input[type=range]').forEach(control => { control.value = control.defaultValue; });
        input.setCustomValidity('');
        await this.processPortrait(index, version);
      } catch {
        if (state.version === version) input.setCustomValidity(this.text('fileError'));
      } finally {
        URL.revokeObjectURL(url);
        if (state.version === version) {
          state.loading = false;
          this.render();
          if (input.validationMessage) input.reportValidity();
        }
      }
    }

    syncFields() {
      const total = Number(this.count.value);
      this.fields.forEach((field, index) => {
        const active = index < total;
        field.hidden = !active;
        field.querySelectorAll('input, select').forEach(input => {
          input.disabled = !active || (input.matches('[data-portrait-style]') && !this.serviceUrl);
          if (!active) {
            input.value = input.type === 'range' ? input.defaultValue : input.matches('[data-portrait-style]') ? 'natural' : '';
            input.setCustomValidity('');
          }
        });
        field.querySelector('input[type=file]').required = active;
        if (!active) {
          this.states[index].version++;
          this.states[index].abort?.abort();
          this.states[index].sourceImage = null;
          this.states[index].results?.clear();
          this.states[index].processed = false;
          const processedInput = this.querySelector('[data-processed-file="' + (index + 1) + '"]');
          processedInput.value = '';
          processedInput.disabled = true;
          this.states[index].image = null;
          this.states[index].loading = false;
        }
      });
    }

    updateVariant(id) {
      const selected = String(id || this.form.querySelector('[name=id]')?.value || this.dataset.toteVariant);
      this.kind = selected === this.dataset.beachVariant ? 'beach' : 'tote';
      this.dataset.previewKind = this.kind;
      this.querySelector('[data-bag-label]').textContent = this.text(this.kind + 'Label');
      this.querySelector('[data-layout-property]').value = 'circle-portrait-v4/' + this.kind;
      this.render();
    }

    mountGallery(signal) {
      this.gallery = this.closest('.m-main-product--wrapper')?.querySelector('.m-main-product--media');
      if (!this.gallery || this.gallery.querySelector('[data-pet-gallery-panel]')) return;
      this.galleryPanel = this.querySelector('[data-gallery-template]').content.firstElementChild.cloneNode(true);
      this.gallery.prepend(this.galleryPanel);
      this.gallery.classList.add('pet-preview-gallery');
      this.classList.add('pet-preview-has-gallery');
      this.galleryCanvas = this.galleryPanel.querySelector('canvas');
      this.galleryPanel.querySelectorAll('[data-gallery-tab]').forEach(button => {
        button.addEventListener('click', () => this.setGalleryMode(button.dataset.galleryTab === 'preview'), {signal});
      });
      this.galleryPanel.querySelector('[data-gallery-expand]').addEventListener('click', () => {
        this.dialog.showModal();
        this.copyLarge();
      }, {signal});
      this.setGalleryMode(true);
    }

    setGalleryMode(preview) {
      if (!this.galleryPanel) return;
      this.gallery.classList.toggle('pet-preview-gallery-active', preview);
      this.galleryPanel.querySelectorAll('[data-gallery-tab]').forEach(button => {
        button.setAttribute('aria-pressed', String((button.dataset.galleryTab === 'preview') === preview));
      });
    }

    getPortraitLayout(total, beach = this.kind === 'beach') {
      return petPortraitDesign.layout(total, beach);
    }

    cropValues(field) {
      return Object.fromEntries(['zoom', 'x', 'y'].map(key => [key, Number(field.querySelector('[data-crop-' + key + ']').value)]));
    }

    portraitFor(index) {
      const state = this.states[index];
      return {...state, image:state.image || this.examples[index], processed:state.image ? state.processed : true};
    }

    mountCanvasGestures(signal) {
      const update = (index, crop) => {
        const field = this.fields[index];
        Object.entries(crop).forEach(([key, value]) => { field.querySelector('[data-crop-' + key + ']').value = value; });
        this.render();
      };
      const targets = () => {
        if (!this.templateReady) return [];
        const total = Number(this.count.value);
        const layout = this.getPortraitLayout(total);
        return this.states.slice(0, total).map((state, index) => ({...this.portraitFor(index), index, crop:this.cropValues(this.fields[index]), cx:layout.centers[index], cy:layout.centerY, size:layout.size}));
      };
      [this.canvas, this.galleryCanvas, this.largeCanvas].filter(Boolean).forEach(canvas => petPortraitDesign.bind(canvas, targets, update, signal));
      this.fields.forEach((field, index) => {
        const canvas = field.querySelector('[data-crop-canvas]');
        petPortraitDesign.bind(canvas, () => field.hidden ? [] : [{...this.portraitFor(index), index, crop:this.cropValues(field), cx:160, cy:160, size:304}], update, signal);
      });
    }

    async processPortrait(index, existingVersion) {
      const field = this.fields[index];
      const state = this.states[index];
      if (!state.sourceImage) return;
      const input = field.querySelector('input[type=file]');
      const output = this.querySelector('[data-processed-file="' + (index + 1) + '"]');
      const select = field.querySelector('[data-portrait-style]');
      const version = existingVersion ?? ++state.version;
      state.abort?.abort();
      state.processed = false;
      state.image = state.sourceImage;
      output.value = '';
      output.disabled = true;
      input.setCustomValidity('');
      const style = this.serviceUrl ? select.value : 'original';
      if (style === 'original') { state.loading = false; this.render(); return; }
      state.loading = true;
      input.setCustomValidity(this.text('processingPhoto'));
      this.render();
      const source = input.files[0];
      const run = async () => {
        if (state.version !== version || !this.isConnected) return;
        state.abort = new AbortController();
        let url;
        try {
          let response;
          const cacheKey = style;
          let blob = state.results?.get(cacheKey);
          if (!blob) {
            for (let attempt = 0; attempt < 4; attempt++) {
              response = await fetch(this.serviceUrl + '/v1/portrait?style=' + encodeURIComponent(style) + '&remove_background=true', {
                method: 'POST', headers: {'Content-Type': source.type}, body: source, signal: AbortSignal.any([state.abort.signal, AbortSignal.timeout(45000)]),
              });
              if (response.status !== 503 || attempt === 3) break;
              await new Promise(resolve => setTimeout(resolve, 1200));
              if (state.version !== version) return;
            }
            if (!response.ok) throw new Error('Portrait processing failed');
            blob = await response.blob();
            if (blob.type !== 'image/png') throw new Error('Invalid portrait response');
            if (state.version !== version || !this.isConnected) return;
            state.results ??= new Map();
            state.results.set(cacheKey, blob);
          }
          url = URL.createObjectURL(blob);
          const image = await this.loadImage(url);
          const fitted = await this.trimPortrait(image);
          if (state.version !== version || !this.isConnected) return;
          state.image = fitted;
          state.processed = true;
          const files = new DataTransfer();
          files.items.add(new File([blob], 'pet-' + (index + 1) + '-' + style + '.png', {type: 'image/png'}));
          output.files = files.files;
          output.disabled = false;
          input.setCustomValidity('');
          this.setGalleryMode(true);
        } catch (error) {
          if (state.version === version && error.name !== 'AbortError') input.setCustomValidity(this.text('processingError'));
        } finally {
          if (url) URL.revokeObjectURL(url);
          if (state.version === version) { state.loading = false; this.render(); }
        }
      };
      this.portraitQueue = (this.portraitQueue || Promise.resolve()).catch(() => {}).then(run);
      return this.portraitQueue;
    }

    async trimPortrait(image) {
      const surface = document.createElement('canvas');
      surface.width = image.naturalWidth;
      surface.height = image.naturalHeight;
      const context = surface.getContext('2d', {willReadFrequently: true});
      context.drawImage(image, 0, 0);
      const pixels = context.getImageData(0, 0, surface.width, surface.height).data;
      let left = surface.width, right = 0, top = surface.height, bottom = 0;
      for (let y = 0; y < surface.height; y++) {
        for (let x = 0; x < surface.width; x++) {
          if (pixels[(y * surface.width + x) * 4 + 3] > 20) {
            left = Math.min(left, x); right = Math.max(right, x);
            top = Math.min(top, y); bottom = Math.max(bottom, y);
          }
        }
      }
      if (right <= left || bottom <= top) return image;
      const cropped = document.createElement('canvas');
      cropped.width = right - left + 1;
      cropped.height = bottom - top + 1;
      cropped.getContext('2d').drawImage(surface, left, top, cropped.width, cropped.height, 0, 0, cropped.width, cropped.height);
      return this.loadImage(cropped.toDataURL('image/png'));
    }
    drawPortrait(state, field, width) {
      return petPortraitDesign.portrait(state.image, state.processed, this.cropValues(field), width);
    }

    render() {
      if (!this.context) return;
      const total = Number(this.count.value);
      const activeStates = this.states.slice(0, total);
      const ready = activeStates.filter(state => state.image).length;
      this.fields.forEach((field, index) => {
        const input = field.querySelector('input[type=file]');
        field.querySelector('[data-file-name]').textContent = input.files[0]?.name || this.text('noPhoto');
        field.querySelector('[data-pet-name]').placeholder = this.states[index].image ? this.text('namePlaceholder') : this.exampleNames[index];
        field.querySelector('[data-adjust-photo]').hidden = !this.portraitFor(index).image;
        field.querySelector('[data-photo-error]').textContent = input.files[0] && !this.states[index].loading ? input.validationMessage : '';
        const crop = Object.fromEntries(['zoom', 'x', 'y'].map(key => [key, Number(field.querySelector('[data-crop-' + key + ']').value)]));
        field.querySelector('[data-crop-property]').value = JSON.stringify(crop);
        field.querySelector('[data-zoom-value]').textContent = crop.zoom + '%';
        const editor = field.querySelector('[data-crop-canvas]');
        const editorCtx = editor.getContext('2d');
        editorCtx.clearRect(0, 0, 320, 320);
        if (this.portraitFor(index).image) editorCtx.drawImage(this.drawPortrait(this.portraitFor(index), field, 304), 8, 8, 304, 304);
      });
      const loading = activeStates.some(state => state.loading);
      const designNames = this.querySelector('[data-design-names]');
      designNames.value = petPortraitDesign.combineNames(activeStates.map((state, index) => state.image ? this.fields[index].querySelector('[data-pet-name]').value.trim() : ''));
      designNames.disabled = ready !== total || loading;
      let caption = this.text(ready === total ? 'previewReady' : ready ? 'previewPartial' : 'previewEmpty');
      if (loading) caption = this.text(this.serviceUrl ? 'processingPhoto' : 'loadingPhoto');
      if (!this.templateReady) caption = this.text(this.templateFailed ? 'previewError' : 'loadingPreview');
      this.querySelector('[data-preview-status]').textContent = ready === total && this.templateReady && !loading && activeStates.every((state, index) => !this.fields[index].querySelector('input[type=file]').validationMessage) ? this.text('statusReady') : this.text(!ready && !loading && this.templateReady ? 'statusExample' : 'statusProgress');
      this.querySelector('[data-preview-caption]').textContent = caption;
      this.querySelector('[data-large-caption]').textContent = caption;
      if (this.galleryPanel) {
        this.galleryPanel.querySelector('[data-gallery-caption]').textContent = caption;
        this.galleryPanel.querySelector('[data-gallery-label]').textContent = this.text(this.kind + 'Label');
        this.galleryPanel.querySelector('[data-gallery-expand]').disabled = !this.templateReady;
      }
      this.querySelector('[data-expand-preview]').disabled = !this.templateReady;
      this.canvas.setAttribute('aria-label', this.text('previewLabel') + ' · ' + this.text(this.kind + 'Label') + ' · ' + activeStates.map((state, index) => this.fields[index].querySelector('[data-pet-name]').value.trim() || (!state.image ? this.exampleNames[index] : '')).filter(Boolean).join(', ') + (ready < total ? ' · ' + this.text('statusExample') : ''));
      const ctx = this.context;
      ctx.clearRect(0, 0, 960, 960);
      ctx.fillStyle = '#f9f4e9';
      ctx.fillRect(0, 0, 960, 960);
      if (!this.templateReady) return;
      const beach = this.kind === 'beach';
      if (beach) ctx.drawImage(this.assets.beach, 0, 0, 960, 960);
      const pets = activeStates.map((state, index) => {
        const field = this.fields[index];
        return {...this.portraitFor(index), crop:this.cropValues(field), name:field.querySelector('[data-pet-name]').value.trim() || (!state.image ? this.exampleNames[index] : '')};
      });
      petPortraitDesign.composition(ctx, pets, beach);
      ctx.drawImage(beach ? this.assets.beachOverlay : this.assets.tote, 0, 0, 960, 960);
      this.canvas.dataset.rendered = 'true';
      this.canvas.dataset.photoCount = String(ready);
      this.canvas.dataset.exampleCount = String(activeStates.filter((state, index) => !state.image && this.examples[index]).length);
      if (this.galleryCanvas) {
        const galleryCtx = this.galleryCanvas.getContext('2d');
        galleryCtx.clearRect(0, 0, 960, 960);
        galleryCtx.drawImage(this.canvas, 0, 0);
        this.galleryCanvas.setAttribute('aria-label', this.canvas.getAttribute('aria-label'));
      }
      this.copyLarge();
    }

    copyLarge() {
      if (!this.dialog.open) return;
      const ctx = this.largeCanvas.getContext('2d');
      this.largeCanvas.setAttribute('aria-label', this.canvas.getAttribute('aria-label'));
      ctx.clearRect(0, 0, 960, 960);
      ctx.drawImage(this.canvas, 0, 0);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.states?.forEach(state => { state.version++; state.abort?.abort(); });
      this.dialog?.close();
      this.galleryPanel?.remove();
      this.gallery?.classList.remove('pet-preview-gallery', 'pet-preview-gallery-active');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
